import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { ContentCard, EmptyState, LoadingState, PageHeader, Section } from '../components/public/ui';

const Students = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const response = await api.get('/public/students');
        setStudents(response.data.data);
      } catch (error) {
        console.error('Error fetching students:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchStudents();
  }, []);

  const getInitials = (firstName, lastName) =>
    `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();

  const photoUrl = (path) => {
    if (!path) return null;
    const base = (process.env.REACT_APP_API_URL || '').replace('/api', '');
    return `${base}/uploads/${path}`;
  };

  if (loading) return <LoadingState />;

  return (
    <Section className="section-pad">
      <PageHeader
        title="Nuestros alumnos"
        lead="Miembros destacados de Team Kitsune."
      />

      {students.length === 0 ? (
        <EmptyState title="Sin alumnos" description="Pronto veremos caras nuevas aquí." />
      ) : (
        <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {students.map((student) => {
            const src = photoUrl(student.photo_path);
            return (
              <li key={student.id}>
                <ContentCard className="flex h-full flex-col items-center text-center">
                  {src ? (
                    <img
                      src={src}
                      alt=""
                      className="h-24 w-24 rounded-full object-cover"
                    />
                  ) : (
                    <div className="flex h-24 w-24 items-center justify-center rounded-full bg-primary font-display text-2xl font-bold text-white">
                      {getInitials(student.first_name, student.last_name)}
                    </div>
                  )}
                  <h2 className="mt-4 font-display text-2xl font-semibold uppercase tracking-wide">
                    {student.first_name} {student.last_name}
                  </h2>
                  {student.belt_name && (
                    <span
                      className="mt-2 rounded-full px-3 py-1 text-xs font-semibold text-white"
                      style={{ backgroundColor: student.belt_color || '#000' }}
                    >
                      {student.belt_name}
                    </span>
                  )}
                  {student.biography && (
                    <p className="mt-4 line-clamp-4 text-sm text-muted">{student.biography}</p>
                  )}
                </ContentCard>
              </li>
            );
          })}
        </ul>
      )}
    </Section>
  );
};

export default Students;
